import { useEffect, useState } from "react";
import { setToken } from "../services/api";

const S = {
  page: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0d1117", color: "#f1f5f9", fontFamily: "inherit", padding: 24, textAlign: "center" },
  card: { maxWidth: 420 },
  title: { fontSize: 18, fontWeight: 700, marginBottom: 10 },
  msg: { fontSize: 14, color: "#94a3b8", lineHeight: 1.6 },
};

export default function DemoAccess({ token }) {
  const [state, setState] = useState("loading"); // loading | error

  useEffect(() => {
    fetch(`/api/public/demo/${token}`)
      .then(r => r.json().then(data => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || !data.token) {
          setState(data.error || "Ce lien de démo n'est plus valide.");
          return;
        }
        setToken(data.token);
        window.location.href = "/";
      })
      .catch(() => setState("Impossible de contacter le serveur. Réessayez dans quelques instants."));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={S.page}>
      <div style={S.card}>
        {state === "loading" ? (
          <>
            <div style={S.title}>Préparation de votre démo…</div>
            <div style={S.msg}>Un instant, nous chargeons votre accès.</div>
          </>
        ) : (
          <>
            <div style={S.title}>Lien de démo indisponible</div>
            <div style={S.msg}>{state}</div>
          </>
        )}
      </div>
    </div>
  );
}
